var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-loader-overlay"},[_c('div',{staticClass:"app-loader-box"},[_c('div',{staticClass:"spinner"}),(_vm.text)?_c('div',{staticClass:"app-loader-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }